<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('customer.editContactPerson') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="customer-contact-person-edit-form" tag="form" @keydown.enter.prevent>
          <div class="form-group">
            <label>
              {{ $t('ui.nameAndSurename') }}:
            </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('ui.emailAddress') }}:
            </label>

            <validation-provider
              rules="required|email"
              name="email"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="email"
                v-model="email" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('customer.telephone') }}:
            </label>

            <validation-provider
              rules="required"
              name="phone"
              v-slot="{ errors }">
              <d-input
                v-mask="'+## ### ### ### ### ### ### ### ### ###'"
                :state="errors.length ? 'invalid' : null"
                v-model="phone" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('ui.saveChanges') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-contact-person-edit-popup',
  props: {
    customerID: {
      default: 0,
      type: Number
    },
    contactPersonData: {
      default: () => ({}),
      type: Object
    },
    mode: {
      default: 'partner',
      type: String
    }
  },
  data () {
    return {
      id: 0,
      name: '',
      email: '',
      phone: '',
      fresh_mail_integrated_at: null,
      exclude_from_stock_report: false,
      mailing_consent: false
    };
  },
  mounted () {
    this.id = this.contactPersonData.id;
    this.name = this.contactPersonData.name;
    this.email = this.contactPersonData.email;
    this.phone = this.contactPersonData.phone;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('customer-edit-contact-person-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-contact-person-edit-form'], this.saveContactPerson);
    },
    saveContactPerson () {
      let formDataToSave = {
        customer_id: this.customerID === 0 ? this.$store.getters.getCustomerID : this.customerID,
        name: this.name,
        email: this.email,
        phone: this.phone
      };

      let endpoint = '/customer-panel/customers/contacts/update/' + this.id;

      if (this.mode === 'partner-customer') {
        endpoint = '/customer-panel/partner-customers/contacts/update/' + this.id;
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint,
        formData: formDataToSave,
        successTitle: this.$t('customer.editContactPersonSuccessTitle'),
        successText: this.$t('customer.editContactPersonSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('customer.editContactPersonErrorText'),
        successAction: () => {
          this.$bus.$emit('customer-reload-contact-persons');
          this.handleClose();
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
